import { observer } from "mobx-react-lite";
import React from "react";
import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { GridTypes } from "../../../../../../enums";
import { Uploader } from "../../../../../../components/ui/UploaderFlow/Uploader";
import { BusinessAreaAddon } from "../../../../../../components/ui/UploaderFlow/addons/EntityRelationAddons/BusinessAreaAddon/BusinessAreaAddon";

interface BusinessAreaUploaderModalProps {
  columnConfig: IUploaderColumnConfig[];
  onSubmit: any;
}

export const BusinessAreaUploaderModal: React.FC<ReactProps & BusinessAreaUploaderModalProps> = observer(
  ({ columnConfig, onSubmit }) => {
    return (
      <Uploader
        gridType={GridTypes.BUSINESS_AREAS_GRID}
        fields={columnConfig}
        isOpen={true}
        onClose={() => {
          console.log("closed uploader");
        }}
        onSubmit={onSubmit}
        addons={[BusinessAreaAddon]}
      />
    );
  }
);
